module.exports = __webpack_public_path__ + "assets/images/plus_purple.svg?b95d74cc814ff45cbaf3ec63c6a499ed";


//////////////////
// WEBPACK FOOTER
// ./_source/images/icons/sessions/plus_purple.svg
// module id = 366
// module chunks = 0